import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSmsConfiguration } from 'services/smsConversations';
import { ISMSConfiguration } from 'services/smsConversations/types';

export const ThunkGetSmsConfiguration = createAsyncThunk<ISMSConfiguration, number>(
  'pod/getSmsConfiguration',
  async configId => {
    const r = await getSmsConfiguration(configId);
    return r.data;
  },
);
